import {Component, OnInit} from '@angular/core';
import {KfRegistrationAdminService} from '../../services/kf-registration-admin.service';
import {ActivatedRoute, Router} from '@angular/router';
import {KfRegistration} from '../../../shared/models/kf-registration.interface';
import {KfRegistrationDetail} from '../../../kf-data-entry/models/kf-registration-detail.interface';
import {Master} from '../../../admin/models/master.interface';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {FormBuilder, FormControl} from '@angular/forms';
import {Location} from '@angular/common';

@Component({
  selector: 'app-kf-registration-validation',
  templateUrl: './kf-registration-validation.component.html',
  styleUrls: ['./kf-registration-validation.component.scss']
})
export class KfRegistrationValidationComponent implements OnInit {

  kfRegistration!: KfRegistration;
  kfRegistrationDetail!: KfRegistrationDetail;
  categories: Master[] = [];
  keyFigures!: string;
  existsPreviousYear = false;

  b2bIncludes = [
    'WEEE from non- household sources (e.g., hospital)',
    'WEEE from manufacturers (e.g., stocks, recalls etc.)',
    'WEEE from other sources (small businesses)',
    'Some WEEE with a financial scheme different from household WEEE',
    'All WEEE with a financial scheme different from household WEEE'
  ];

  generalInfoForm = this.formBuilder.group({
    estimatedDetermined: [{value: '', disabled: true}],
    b2bb2c: [{value: '', disabled: true}],
    b2bIncludes: [{value: [], disabled: true}],
    source: [{value: '', disabled: true}],
    confidential: [{value: false, disabled: true}],
    clearedWeee: [{value: false, disabled: true}],
    notes: [{value: '', disabled: true}],
  });

  get estimatedDeterminedControl(): FormControl {
    return this.generalInfoForm.get('estimatedDetermined') as FormControl;
  }

  get b2bb2cControl(): FormControl {
    return this.generalInfoForm.get('b2bb2c') as FormControl;
  }

  get b2bIncludesControl(): FormControl {
    return this.generalInfoForm.get('b2bIncludes') as FormControl;
  }

  get sourceControl(): FormControl {
    return this.generalInfoForm.get('source') as FormControl;
  }

  get confidentialControl(): FormControl {
    return this.generalInfoForm.get('confidential') as FormControl;
  }

  get clearedWeeeControl(): FormControl {
    return this.generalInfoForm.get('clearedWeee') as FormControl;
  }

  get notesControl(): FormControl {
    return this.generalInfoForm.get('notes') as FormControl;
  }

  constructor(private kfRegistrationAdminService: KfRegistrationAdminService,
              private activatedRoute: ActivatedRoute,
              private readonly formBuilder: FormBuilder,
              private dialog: MatDialog,
              readonly router: Router,
              readonly location: Location) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(data => {
        this.keyFigures = data.keyFigures;
        this.kfRegistrationAdminService.get(data.keyFigures, data.referenceId)
          .subscribe(response => {
            this.kfRegistration = response.content;
            this.kfRegistrationAdminService.getKfRegistration(data.keyFigures, this.kfRegistration.year,
              this.kfRegistration.countryId ? 'country' : 'system',
              this.kfRegistration.countryId ? this.kfRegistration.countryId : this.kfRegistration.weeeSystemId
            ).subscribe(kfRegistrationDetail => {
              this.kfRegistrationAdminService.existsPreviousYear(this.keyFigures, this.kfRegistration.year,
                (this.kfRegistration.countryId  ? this.kfRegistration.countryId : this.kfRegistration.weeeSystemId) || 0,
                this.kfRegistration.countryId ? 'country' : 'system').subscribe(exists => {
                  this.existsPreviousYear = exists;
              });
              this.kfRegistrationDetail = kfRegistrationDetail;
              // set general info
              this.estimatedDeterminedControl.setValue(this.kfRegistrationDetail.kfRegistration.detailStatusLevel);
              this.b2bb2cControl.setValue(this.kfRegistrationDetail.kfRegistration.detailLevel);
              if (this.kfRegistrationDetail.kfRegistration.b2bIncludes) {
                this.b2bIncludesControl.setValue(JSON.parse(this.kfRegistrationDetail.kfRegistration.b2bIncludes));
              }
              this.confidentialControl.setValue(this.kfRegistrationDetail.kfRegistration.noDataReport);
              this.clearedWeeeControl.setValue(this.kfRegistrationDetail.kfRegistration.clearedWeee);
              this.notesControl.setValue(this.kfRegistrationDetail.kfRegistration.commentAdminUser);
              this.kfRegistrationDetail.categories.forEach(category => {
                if (category.keyFiguresCategory) {
                  this.categories?.push(category.keyFiguresCategory);
                }
              });
            });
          });
      }
    );
  }

  validate(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        item: 'admin.kf-registration.validate'
      },
      maxWidth: 600
    });
    dialogRef.componentInstance.confirmEvent.subscribe(() => {
      this.kfRegistrationAdminService.validate(
        this.kfRegistration.keyFigures.toLowerCase(), this.kfRegistration.year,
        this.kfRegistration.countryId ? 'country' : 'system',
        this.kfRegistration.countryId ? this.kfRegistration.countryId : this.kfRegistration.weeeSystemId,
      )
        .subscribe(
          () => {
            this.router.navigate(['/kfreporting/kfregistration/validation-center'],
              {state: {message: 'The registration has been successfully validated'}});
          });
      dialogRef.close();
    });
  }

  reopen(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        item: 'admin.kf-registration.reopen'
      },
      maxWidth: 600
    });
    dialogRef.componentInstance.confirmEvent.subscribe(() => {
      this.kfRegistrationAdminService.reopen(
        this.kfRegistration.keyFigures.toLowerCase(), this.kfRegistration.year,
        this.kfRegistration.countryId ? 'country' : 'system',
        this.kfRegistration.countryId ? this.kfRegistration.countryId : this.kfRegistration.weeeSystemId,
      )
        .subscribe(
          () => {
            this.router.navigate(['/kfreporting/kfregistration/validation-center'],
              {state: {message: 'The registration has been successfully validated'}});
          });
      dialogRef.close();
    });
  }

  markNotValidable(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        item: 'admin.kf-registration.notValidable'
      },
      maxWidth: 600
    });
    dialogRef.componentInstance.confirmEvent.subscribe(() => {
      this.kfRegistrationAdminService.markAsNotValidable(
        this.kfRegistration.keyFigures.toLowerCase(), this.kfRegistration.year,
        this.kfRegistration.countryId ? 'country' : 'system',
        this.kfRegistration.countryId ? this.kfRegistration.countryId : this.kfRegistration.weeeSystemId,
      )
        .subscribe(
          () => {
            this.router.navigate(['/kfreporting/kfregistration/validation-center'],
              {state: {message: 'The registration has been successfully saved'}});
          });
      dialogRef.close();
    });
  }

  print(): void {
    this.printRegistration(this.kfRegistration.year);
  }

  printLastYear(): void {
    this.printRegistration(this.kfRegistration.year - 1);
  }

  private printRegistration(year: number): void {
    this.kfRegistrationAdminService.printPdf(this.kfRegistration.keyFigures, year,
      (this.kfRegistration.countryId ? this.kfRegistration.countryId : this.kfRegistration.weeeSystemId) || 0,
      this.kfRegistration.countryId ? 'country' : 'system')
      .subscribe(response => {
        const blob = new Blob([response.body], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }
}
